import { rtkApi } from "../../../shared/api/rtkApi";
import {
    CareerBackInterfacesCareerBackModelsStatusActionResult1SystemCollectionsGenericIReadOnlyCollection1SystemString,
    CareerBackInterfacesDTOJobExperienceDto,
    CareerBackInterfacesDTOVacancyExpandVacancyDto,
    CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto,
    CareerBackInterfacesDTOVacancyVacancyPreviewDto,
} from "../../../shared/ApiContract/data-contracts";
import { SearchParamsVacancyEnum } from "../../../shared/constants/searchParams";
import { removeNullKeys } from "../../../shared/lib/helpers";

const vacancyApi = rtkApi.injectEndpoints({
    endpoints: (build) => ({
        getVacancy: build.query<CareerBackInterfacesDTOVacancyExpandVacancyDto | null, string>({
            query: (id) => ({
                url: `vacancy/${id}`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOVacancyExpandVacancyDto) => response,
        }),

        getVacancyList: build.query<any[], Partial<Record<SearchParamsVacancyEnum, unknown>> | void>({
            query: (params) => ({
                url: `vacancy/allVacancies?${new URLSearchParams(removeNullKeys(params ?? {}))}`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto[]) => response,
        }),

        getDirectionVacancyList: build.query<
            CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto,
            Partial<Record<SearchParamsVacancyEnum, unknown>> | void
        >({
            query: (params) => ({
                url: `vacancy/directionVacancies?${new URLSearchParams(removeNullKeys(params ?? {}))}`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto) => response,
        }),

        getVacancyCity: build.query<
            CareerBackInterfacesCareerBackModelsStatusActionResult1SystemCollectionsGenericIReadOnlyCollection1SystemString,
            void
        >({
            query: () => ({
                url: `cities/filter`,
            }),
            transformResponse: (
                response: CareerBackInterfacesCareerBackModelsStatusActionResult1SystemCollectionsGenericIReadOnlyCollection1SystemString,
            ) => response,
        }),

        getHotVacancies: build.query<CareerBackInterfacesDTOVacancyVacancyPreviewDto[], void>({
            query: () => ({
                url: `vacancy/hot`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOVacancyVacancyPreviewDto[]) => response,
        }),
        getJobExperience: build.query<CareerBackInterfacesDTOJobExperienceDto[], void>({
            query: () => ({
                url: `vacancy/jobExperience`,
            }),
            transformResponse: (response: CareerBackInterfacesDTOJobExperienceDto[]) => response,
        }),
        getModeratedCount: build.query<number, void>({
            query: () => ({
                url: `vacancy/moderatedCount`,
            }),
            transformResponse: (response: number) => response,
        }),
    }),
});

export const {
    useGetVacancyCityQuery,
    useGetVacancyQuery,
    useGetVacancyListQuery,
    useGetDirectionVacancyListQuery,
    useGetHotVacanciesQuery,
    useGetJobExperienceQuery,
    useGetModeratedCountQuery,
} = vacancyApi;
